import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import styles from "./Dashboard.module.scss";

import AppLayoutWrapFull from "components/AppLayoutWrapFull";
import Container from "components/Container/Container";
import Tabs from "components/Tabs/Tabs";
import DocumentsTab from "./components/DocumentsTab/DocumentsTab";
import IncidentsTab from "./components/IncidentsTab/IncidentsTab";
import TasksTab from "./components/TasksTab/TasksTab";
import AttestDocumentModal from "./components/DocumentsTab/AttestDocumentModal/AttestDocumentModal";

// import TrainingTab from "./components/TrainingTab/TrainingTab";
import { loadUserStatsAction } from "store/actions/Actions";

// import StagesStepper from "./components/StagesStepper/StagesStepper";
import PieChartBox from "./components/PieChartBox/PieChartBox";

const Dashboard = props => {
    const [activeTab, setActiveTab] = useState("DOCUMENTS");
    const [showModal, setShowModal] = useState(false);
    const [attestationId, setAttestationId] = useState(false);

    const { UserStatsReducer, loadUserStatsAction, UserOrgSiteReducer } = props;
    const {entity, id} = props.match.params;

    useEffect(() => {
        if (!UserStatsReducer.stats) {
            loadUserStatsAction();
        }
    }, [UserStatsReducer.stats, loadUserStatsAction]);

    useEffect(() => {
        if (entity && entity === 'task'){
            setActiveTab("MY TASKS");
        }
    }, [entity]);


    useEffect(() => {
        if (activeTab === 'DASHBOARD') {
            setActiveTab('DOCUMENTS');
        }
    }, [activeTab]);

    const setTabAsActive = heading => () => {
        setActiveTab(heading);
    };

    const is_admin = (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_admin) || false;

    return (
        <AppLayoutWrapFull setActiveTab={setActiveTab}>
            <div id="modal-root"></div>
            {UserStatsReducer.stats ? <>
            <div className={styles.overview}>
                <Container wide dashboard>
                    <h2 className={styles.heading}>Compliance Overview</h2>
                    <div className={styles.boxes}>
                    {UserStatsReducer.stats &&
                    <>
                        <PieChartBox
                            key="tasks"
                            title="Tasks"
                            desc="Number of tasks that are assigned and closed versus open"
                            complete={UserStatsReducer.stats.tasks.complete}
                            total={UserStatsReducer.stats.tasks.total}
                            color="#0a407e"
                            bg="#b3c2d4"
                            link={""}
                        />
                        <PieChartBox
                            key="training"
                            title="Training"
                            desc="Number of trainings completed"
                            complete={props.files && props.files.filter(item => item.understood && item.requires_attest).length}
                            total={props.files && props.files.filter(item => item.requires_attest).length}
                            color="#1e98ca"
                            bg="#c2dde8"
                            link={""}
                        />
                    </>
                    }
                    </div>
                </Container>
            </div>
            <Tabs
                dashboard
                tabs={[
                    {
                        heading: "DOCUMENTS",
                        icon: "fad fa-copy"
                    },
                    {
                        heading: "INCIDENTS",
                        icon: "fad fa-comment-alt-exclamation"
                    },
                    {
                        heading: "MY TASKS",
                        icon: "fad fa-tasks"
                    },
                    // {
                    //     heading: "TRAINING",
                    //     icon: "fal fa-users-class"
                    // }
                ]}
                setActiveTab={setTabAsActive}
                activeTab={activeTab}
                className={styles.tabs}
            >
                {/* Tab Content */}
                <Container wide dashboard>
                    {
                        {
                            DOCUMENTS: <DocumentsTab isAdmin={is_admin} setShowModal={setShowModal} setAttestationId={setAttestationId} />,
                            INCIDENTS: <IncidentsTab allowAdd={true} isAdmin={is_admin} id={entity === 'incident' ? id : null}/>,
                            "MY TASKS": <TasksTab isAdmin={is_admin} id={entity === 'task' ? id : null} />,
                            // TRAINING: <TrainingTab />
                        }[activeTab]
                    }
                </Container>
            </Tabs>
            </> : ""
            }
            {showModal ? (
                <AttestDocumentModal
                    setShowModal={setShowModal}
                    attestationId={attestationId}
                />
            ) : null}
        </AppLayoutWrapFull>
    );
};

const mapStateToProps = (state) => ({
    UserStatsReducer: state.UserStatsReducer,
    files: state.AttestationsReducer.files,
    UserOrgSiteReducer: state.UserOrgSiteReducer,
});

const mapDispatchToProps = {
    loadUserStatsAction,
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(Dashboard)
);
